
import cmsBlock from '~/mixins/cmsBlock'
import lazyBgImage from '~/mixins/lazyBgImage'

export default {
  name: 'CmsMediclubCardsSport',
  mixins: [cmsBlock, lazyBgImage],

  data () {
    return {
      fallbackContent: {
        header: 'Cards',
        subheader: 'Cards subheader',
        items: [
          {
            title: 'Physical Activity',
            bgImg: '/mc/v3/block4/bg/Physical.png',
            ico: '/mc/v3/block4/ico/physicalActivity.svg',
            to: '/url',
            desc: [
              '<b>5000</b> facilities',
              'Mobile application',
              'Simple finder',
              'Milions offerts',
            ],
          },
          {
            title: 'Prevention',
            bgImg: '/mc/v3/block4/bg/Prevention.png',
            ico: '/mc/v3/block4/ico/prevention.svg',
            to: '/url',
            desc: [
              '<b>Consultation</b> with a sports medicine doctor',
              'Comprehensive Health Analysis',
              'Orthopaedist',
              'Sports medicine doctor',
            ],
          },
          {
            title: 'Mental Health',
            bgImg: '/mc/v3/block4/bg/Mental.png',
            ico: '/mc/v3/block4/ico/mentalHealth.svg',
            desc: [
              '<b>Specialist consultations</b>',
              'Psychiatrist',
              'Psychologist',
            ],
          },
          {
            title: 'Nutrition',
            bgImg: '/mc/v3/block4/bg/Nutrition.png',
            ico: '/mc/v3/block4/ico/healthyNutrition.svg',
            desc: [
              'Dietitian and research - <b>Stay slim</b>',
              'Profile of healthy skin, hair and nails',
              'NutriFit - Genetic testing for diet and health',
              'Dietitian consultation',
            ],
          },
        ],
      },
    }
  },
}
